import React, { useState, useEffect } from "react";
import api from "../utils/api";
import "../styles/home.css";
import "../styles/contact.css";

const ContactUs = () => {
  const [contact, setContact] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContact = async () => {
      try {
        console.log("requset sent");
        const res = await api.get("/contact-info");
        console.log("response received", res.data);
        setContact(res.data.data);
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    };
    fetchContact();
  }, []);

  if (loading) {
    return (
      <div className="home-container">
        <div className="hero-section">
          <div className="hero-content">
            <div
              className="floating-card"
              style={{ maxWidth: "400px", margin: "0 auto" }}
            >
              <div
                className="floating-card-icon"
                style={{ margin: "0 auto 1rem" }}
              >
                <svg
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  style={{ width: "100%", height: "100%" }}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                  />
                </svg>
              </div>
              <div className="floating-card-title">
                Loading Contact Information...
              </div>
              <div className="growth-label">
                Please wait while we fetch the details
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!contact) {
    return (
      <div className="home-container">
        <div className="hero-section">
          <div className="hero-content">
            <div
              className="floating-card"
              style={{ maxWidth: "400px", margin: "0 auto" }}
            >
              <div className="floating-card-title" style={{ color: "#ef4444" }}>
                Error Loading Contact
              </div>
              <div className="growth-label">
                Unable to fetch contact information. Please try again later.
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="home-container">
      <div className="hero-section">
        <div className="hero-content" style={{ maxWidth: "1024px" }}>
          {/* Header Section */}
          <div style={{ textAlign: "center", marginBottom: "3rem" }}>
            <div className="trust-badge" style={{ marginBottom: "1rem" }}>
              <svg
                className="trust-badge-icon"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              <span className="trust-badge-text">Get in Touch</span>
            </div>
            <h1 className="hero-title">
              Contact <span className="brand-highlight">Us</span>
            </h1>
            <p className="hero-subtitle">
              Ready to transform your business? We're here to help you succeed.
            </p>
          </div>

          {/* Main Contact Card */}
          <div className="benefits-content" style={{ gap: "2rem" }}>
            {/* Company Information */}
            <div
              className="benefit-highlight-card"
              style={{ maxWidth: "none" }}
            >
              <div className="highlight-icon">
                <svg
                  className="highlight-icon-svg"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H3m2 0h4m0-16v16m6-16v16"
                  />
                </svg>
              </div>
              <div className="highlight-title">{contact.companyName}</div>
              <p
                className="highlight-description"
                style={{ marginBottom: "1rem" }}
              >
                {contact.address}
              </p>

              {/* Contact Details Grid */}
              <div
                style={{ display: "grid", gap: "1rem", marginBottom: "2rem" }}
              >
                {/* Phone */}
                <div
                  className="feature-card"
                  style={{ padding: "1rem", margin: 0 }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem",
                    }}
                  >
                    <div
                      className="stat-icon"
                      style={{ width: "2.5rem", height: "2.5rem" }}
                    >
                      <svg
                        className="stat-icon-svg"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                        />
                      </svg>
                    </div>
                    <div>
                      <div
                        className="feature-title"
                        style={{ fontSize: "1rem", marginBottom: "0.25rem" }}
                      >
                        Phone
                      </div>
                      <div className="feature-description">{contact.phone}</div>
                    </div>
                  </div>
                </div>

                {/* WhatsApp */}
                <div
                  className="feature-card"
                  style={{ padding: "1rem", margin: 0 }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem",
                    }}
                  >
                    <div
                      className="stat-icon"
                      style={{
                        width: "2.5rem",
                        height: "2.5rem",
                        background: "linear-gradient(135deg, #25d366, #128c7e)",
                      }}
                    >
                      <svg
                        className="stat-icon-svg"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
                      </svg>
                    </div>
                    <div>
                      <div
                        className="feature-title"
                        style={{ fontSize: "1rem", marginBottom: "0.25rem" }}
                      >
                        WhatsApp
                      </div>
                      <a
                        href={`https://wa.me/91${contact.whatsapp.replace(
                          /\D/g,
                          ""
                        )}`}
                        className="feature-description"
                        style={{ color: "#25d366", textDecoration: "none" }}
                        onMouseOver={(e) =>
                          (e.target.style.textDecoration = "underline")
                        }
                        onMouseOut={(e) =>
                          (e.target.style.textDecoration = "none")
                        }
                      >
                        {contact.whatsapp}
                      </a>
                    </div>
                  </div>
                </div>

                {/* Email */}
                <div
                  className="feature-card"
                  style={{ padding: "1rem", margin: 0 }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem",
                    }}
                  >
                    <div
                      className="stat-icon"
                      style={{ width: "2.5rem", height: "2.5rem" }}
                    >
                      <svg
                        className="stat-icon-svg"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    <div>
                      <div
                        className="feature-title"
                        style={{ fontSize: "1rem", marginBottom: "0.25rem" }}
                      >
                        Email
                      </div>
                      <a
                        href={`mailto:${contact.email}`}
                        className="feature-description"
                        style={{ color: "#2563eb", textDecoration: "none" }}
                        onMouseOver={(e) =>
                          (e.target.style.textDecoration = "underline")
                        }
                        onMouseOut={(e) =>
                          (e.target.style.textDecoration = "none")
                        }
                      >
                        {contact.email}
                      </a>
                    </div>
                  </div>
                </div>

                {/* Working Hours */}
                <div
                  className="feature-card"
                  style={{ padding: "1rem", margin: 0 }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem",
                    }}
                  >
                    <div
                      className="stat-icon"
                      style={{
                        width: "2.5rem",
                        height: "2.5rem",
                        background: "linear-gradient(135deg, #f59e0b, #d97706)",
                      }}
                    >
                      <svg
                        className="stat-icon-svg"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </div>
                    <div>
                      <div
                        className="feature-title"
                        style={{ fontSize: "1rem", marginBottom: "0.25rem" }}
                      >
                        Working Hours
                      </div>
                      <div className="feature-description">
                        {contact.workingHours}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Action Card */}
            <div className="floating-card" style={{ maxWidth: "none" }}>
              <div className="floating-card-icon" style={{ color: "#10b981" }}>
                <svg
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  style={{ width: "100%", height: "100%" }}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                  />
                </svg>
              </div>
              <div className="floating-card-title">Ready to Get Started?</div>
              <p
                style={{
                  color: "#6b7280",
                  marginBottom: "2rem",
                  fontSize: "0.875rem",
                }}
              >
                Don't hesitate to reach out! We're here to answer your questions
                and help you achieve your goals.
              </p>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                <a
                  href={`https://wa.me/91${contact.whatsapp.replace(
                    /\D/g,
                    ""
                  )}`}
                  className="cta-button"
                  style={{ textDecoration: "none" }}
                >
                  <svg
                    className="button-icon"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
                  </svg>
                  Message on WhatsApp
                </a>

                <a
                  href={`mailto:${contact.email}`}
                  className="cta-button"
                  style={{
                    textDecoration: "none",
                    background: "linear-gradient(135deg, #10b981, #059669)",
                    boxShadow: "0 10px 25px rgba(16, 185, 129, 0.3)",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.background =
                      "linear-gradient(135deg, #059669, #047857)";
                    e.target.style.boxShadow =
                      "0 15px 35px rgba(16, 185, 129, 0.4)";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.background =
                      "linear-gradient(135deg, #10b981, #059669)";
                    e.target.style.boxShadow =
                      "0 10px 25px rgba(16, 185, 129, 0.3)";
                  }}
                >
                  <svg
                    className="button-icon"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  Send an Email
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Trust Section */}
      <div className="trust-section">
        <div className="trust-container">
          <div className="trust-features">
            <div className="trust-feature">
              <div className="trust-feature-icon">
                <svg
                  className="trust-feature-icon-svg"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  />
                </svg>
              </div>
              <span className="trust-feature-text">Secure Communication</span>
            </div>
            <div className="trust-feature">
              <div className="trust-feature-icon">
                <svg
                  className="trust-feature-icon-svg"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </div>
              <span className="trust-feature-text">Quick Response</span>
            </div>
            <div className="trust-feature">
              <div className="trust-feature-icon">
                <svg
                  className="trust-feature-icon-svg"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <span className="trust-feature-text">Professional Support</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
